import React, { useState, useEffect } from 'react';
import { Box, Typography, Card, CardContent, Grid, LinearProgress, Paper } from '@mui/material';
import axios from 'axios';

const Performance = () => {
  const [perfData, setPerfData] = useState([]);

  useEffect(() => {
    fetchPerformance();
  }, []);

  const fetchPerformance = async () => {
    try {
      const res = await axios.get('/api/performance');
      setPerfData(res.data);
    } catch {
      setPerfData([]);
    }
  };

  return (
    <Box sx={{ maxWidth: 700, mx: 'auto', mt: 4 }}>
      <Typography variant="h4" gutterBottom>Performans Değerlendirme</Typography>
      <Grid container spacing={2}>
        {perfData.map((p) => (
          <Grid item xs={12} md={4} key={p.name}>
            <Card>
              <CardContent>
                <Typography variant="h6">{p.name}</Typography>
                <Typography variant="body2">Aylık Skor: {p.score}</Typography>
                <Box sx={{ my: 1 }}>
                  <LinearProgress variant="determinate" value={p.score} sx={{ height: 10, borderRadius: 5 }} />
                </Box>
                <Typography variant="caption" color="text.secondary">{p.comment}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Paper sx={{ mt: 3, p: 2 }}>
        <Typography variant="h6">Genel Analiz</Typography>
        <Typography variant="body2">Bu ayın ortalama performans skoru: {Math.round(perfData.reduce((a, b) => a + b.score, 0) / perfData.length)}</Typography>
      </Paper>
    </Box>
  );
};

export default Performance;
